export default __webpack_public_path__ + "static/media/sticker.70270995.png";